import React, { useState, useEffect } from "react";
// import styles from "./header.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { OptimizedImage } from "../../utils/imageOptimizer";

const Header = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation(); // Get current route
  const [menuActive, setMenuActive] = useState(false); // State to manage mobile menu

  // const handleClick = () => {
  //   navigate("/register");
  //   closeMenu();
  // };

  const handleClick = () => {
    if (
      location.pathname === "/" ||
      location.pathname === "/faq" ||
      location.pathname === "/about"
    ) {
      // Redirect to app store or play store
      window.open("https://play.google.com/store", "_blank");
    } else if (location.pathname === "/becomeapartner") {
      // Navigate to Become Partner page
      // navigate("/becomeapartner");
      navigate("/register");
    } else {
      // Default action (Register page)
      // navigate("/register");
      navigate("/");
    }
    closeMenu(); // Close the mobile menu after navigating
  };

  const handleLogoClick = () => {
    navigate("/");
    closeMenu(); // Close the mobile menu after navigating
  };

  const toggleMenu = () => {
    setMenuActive(!menuActive); // Toggle the menu
  };

  const closeMenu = () => {
    setMenuActive(false); // Close the menu
  };

  useEffect(() => {
    const updateSize = () => {
      if (window.innerWidth >= 767) {
        setMenuActive(false);
      }
    };

    updateSize(); // Run on initial render
    window.addEventListener("resize", updateSize); // Add resize listener
    return () => window.removeEventListener("resize", updateSize); // Cleanup listener
  }, []);

  const getButtonText = () => {
    if (
      location.pathname === "/" ||
      location.pathname === "/faq" ||
      location.pathname === "/about"||
      location.pathname === "/blog"
    ) {
      return t("download_app");
    } else if (location.pathname === "/becomeapartner") {
      return t("become_partner");
    }
    return t("Jetzt Herunterladen");
    // return "REGISTER NOW";
  };

  useEffect(() => {
    setMenuActive(false);
  }, [location.pathname]);

  return (
    <>
      <div className="max-w-[1460px] mx-auto">
        {/* <div className={location.pathname === "/" ? styles.header : styles.header2}> */}
        <div className="w-full min-h-[10vh] hidden md:flex items-center justify-between mt-4 mb-5">
          <div className="w-1/5">
            <OptimizedImage src="/Images/logo-new.webp" alt="Logo" className="w-24 ml-7 cursor-pointer" onClick={handleLogoClick} />
          </div>
          <div className="flex items-center">
            <div
              className="flex justify-center items-center h-8 mt-2 relative"
            >
              <Link to="/">
                <span
                  className={`px-4 py-2 text-lg transition-all duration-200 rounded-full hover:bg-gray-200 ${location.pathname === "/" ? "bg-gray-200" : ""}`}
                >
                  {t("app")}
                </span>
              </Link>
              {/* <Link to="/theapp">
              <span
                className={`${styles.menuSpan} ${location.pathname === "/theapp" ? styles.activeMenu : ""
                  }`}
              >
                The App
              </span>
            </Link> */}
              <Link to="/faq">
                <span
                 className={`px-4 py-2 text-lg transition-all duration-200 rounded-full hover:bg-gray-200 ${location.pathname === "/faq" ? "bg-gray-200" : ""}`}
                >
                  {t("faq")}
                </span>
              </Link>
              <Link to="/about">
                <span
                  className={`px-4 py-2 text-lg transition-all duration-200 rounded-full hover:bg-gray-200 ${location.pathname === "/about" ? "bg-gray-200" : ""}`}
                >
                  {t("about")}
                </span>
              </Link>
              <Link to="/blog">
                <span
                  className={`px-4 py-2 text-lg transition-all duration-200 rounded-full hover:bg-gray-200 ${location.pathname === "/blog" ? "bg-gray-200" : ""}`}
                >
                  {t("blogs")}
                </span>
              </Link>
              <Link to="/becomeapartner">
                <span
                  className={`px-4 py-2 text-lg transition-all duration-200 rounded-full hover:bg-gray-200 ${location.pathname === "/becomeapartner" ? "bg-gray-200" : ""}`}
                  // id={styles.become}
                >
                  {t("become_partner")}
                </span>
              </Link>
              <p></p>
            </div>
            <div className="w-48 h-24 flex justify-center items-center">
              <button className="px-5 py-2 h-11 bg-sky-300 text-gray-800 rounded-lg font-bold text-sm border-none shadow-md cursor-pointer transition-all duration-300 hover:scale-105 hover:shadow-lg hover:bg-primary" onClick={handleClick}>
                {getButtonText()}
              </button>
              {/* <button className={styles.menuButton} onClick={handleClick}>
                REGISTER NOW
              </button> */}
            </div>
          </div>
        </div>
      </div>

      <div className="md:hidden block h-28 relative">
        {/* Mobile Menu Toggle */}
        <div className="w-20 h-32 ml-5 mt-0">
          <OptimizedImage src="/Images/logo-new.webp" alt="Logo" className="cursor-pointer w-full" onClick={handleLogoClick} />
        </div>
        <div
          className="flex flex-col cursor-pointer absolute top-7 right-5 z-10"
          onClick={toggleMenu}
        >
          <div className="w-6 h-1 bg-primary my-1 transition-all duration-200"></div>
          <div className="w-6 h-1 bg-primary my-1 transition-all duration-200"></div>
          <div className="w-6 h-1 bg-primary my-1 transition-all duration-200"></div>
        </div>

        {/* Navbar */}
      </div>
      <div
        className={`md:hidden transition-all duration-300 ${menuActive ? 'block' : 'hidden'} bg-white pb-12`}
      >
        <div className="flex flex-col items-center gap-4">
          <Link to="/" className="p-0">
            <span
              className={`block text-center py-2 px-6 text-base cursor-pointer transition-colors hover:bg-gray-200 rounded ${location.pathname === "/" ? "bg-gray-200" : ""}`}
            >
              {t("app")}
            </span>
          </Link>

          <Link to="/faq" className="p-0">
            <span
              className={`block text-center py-2 px-6 text-base cursor-pointer transition-colors hover:bg-gray-200 rounded ${location.pathname === "/faq" ? "bg-gray-200" : ""}`}
            >
              {t("faq")}
            </span>
          </Link>

          <Link to="/about" className="p-0">
            <span
              className={`block text-center py-2 px-6 text-base cursor-pointer transition-colors hover:bg-gray-200 rounded ${location.pathname === "/about" ? "bg-gray-200" : ""}`}
            >
              {t("about")}
            </span>
          </Link>

          <Link to="/blog" className="p-0">
            <span
              className={`block text-center py-2 px-6 text-base cursor-pointer transition-colors hover:bg-gray-200 rounded ${location.pathname === "/blog" ? "bg-gray-200" : ""}`}
            >
              {t("blogs")}
            </span>
          </Link>

          <Link to="/becomeapartner" className="p-0">
            <span
              className={`block text-center py-2 px-6 text-base cursor-pointer transition-colors hover:bg-gray-200 rounded ${location.pathname === "/becomeapartner" ? "bg-gray-200" : ""}`}
            >
              {t("become_partner")}
            </span>
          </Link>

          <button className="block mx-auto mt-4 w-3/5 py-2 h-11 bg-gray-800 text-white rounded font-medium text-sm transition-all hover:bg-gray-700" onClick={handleClick}>
            {getButtonText()}
          </button>
          {/* <button className={styles.menuButtonMobile} onClick={handleClick}>
              REGISTER NOW
            </button> */}
        </div>
      </div>
    </>
  );
};

export default Header;
